import React, { useEffect, useState, useRef } from "react";
import MUIDataTable from "mui-datatables";
import { Button, ButtonGroup } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import EditLocationAltIcon from "@mui/icons-material/EditLocationAlt";
import {
  GetUserStatusTable,
  GetKycById,
  UserKycChange
} from "../../redux/Actions/userStatusService";
import { GetAllUserStrategies, PatchUserStrategies } from "../../redux/Actions/strategyService";
import UserstatusModal from "../../Modals/userstatusModal";
import Loader from "../../Loader";
import { useNavigate } from "react-router";
import "../../Styles/table.css";
import moment from "moment/moment";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { styled, alpha } from "@mui/material/styles";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";
import UserKycModal from "../../Modals/UserKycModal";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Paper, Typography, Divider, Container, Card, CardContent, Chip, IconButton, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, FormControl, FormGroup, FormControlLabel, Checkbox, Alert, Grid, CircularProgress, Table, TableHead, TableBody, TableRow, TableCell, TextField } from "@mui/material";
import ArticleIcon from '@mui/icons-material/Article';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import GetAppIcon from '@mui/icons-material/GetApp';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableChartIcon from '@mui/icons-material/TableChart';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CloseIcon from '@mui/icons-material/Close';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));
const StyledButton = styled(Button)(({ theme }) => ({
  cursor: "pointer",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "white",
  borderColor: theme.palette.primary.main,
  color: theme.palette.primary.main,
  fontWeight: 700,
  fontSize: "14px",
  "&:hover": {
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
}));
const UserStatusTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userStatusData, setuserStatusData] = useState([]);
  const [openUserModal, setopenUserModal] = useState(false);
  const [openUserModalKyc, setopenUserModalKyc] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const open = Boolean(anchorEl);
  const { userData, loading, userDataCount, userDataSkip, userDataTake } = useSelector(
    (state) => state.userStatus
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [searchText, setSearchText] = useState("");
  const { allUserStrategies, loading: strategiesLoading } = useSelector(
    (state) => state.strategy
  );



  const [showKycDetails, setShowKycDetails] = useState(false);
  const [kycDetailsData, setKycDetailsData] = useState(null);
  const [selectedCustodianForKyc, setSelectedCustodianForKyc] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;
  const [openCustodianSelect, setOpenCustodianSelect] = useState(false);
  const [selectedCustodians, setSelectedCustodians] = useState([]);
  const [tempUserData, setTempUserData] = useState(null);
  const [fileViewerOpen, setFileViewerOpen] = useState(false);
  const [fileToView, setFileToView] = useState(null);
  const [csvData, setCsvData] = useState(null);
  const [isLoadingFile, setIsLoadingFile] = useState(false);
  const [accountIdsModalOpen, setAccountIdsModalOpen] = useState(false);
  const [selectedUserForAccountIds, setSelectedUserForAccountIds] = useState(null);
  const [accountIds, setAccountIds] = useState({});
  const [editableAccountIds, setEditableAccountIds] = useState({});
  const [typingAccountIds, setTypingAccountIds] = useState({});
  const accountIdInputRefs = useRef({});


  useEffect(() => {
    const skip = page * rowsPerPage;
    dispatch(GetUserStatusTable({ skip, take: rowsPerPage }));
  }, [page, rowsPerPage, dispatch]);

  useEffect(() => {
    if (userData && userData.length > 0) {
      let filteredData = userData
        ?.filter((item) => {
          // Filter to only show INVESTOR roles (exclude SUB_INVESTOR which would be in children)
          // Also ensure the user role has a user object with email
          return item.role === 'INVESTOR' && item.user && item.user.email;
        });

      // Apply search filter if searchText is provided
      if (searchText && searchText.trim()) {
        const searchLower = searchText.toLowerCase().trim();
        filteredData = filteredData.filter((item) => {
          const email = item.user?.email?.toLowerCase() || "";
          const investorType = item.investorType?.toLowerCase() || "";
          const entityName = item.entityInfo?.name?.toLowerCase() || "";
          const userInfoFirstName = item.user?.userInfo?.firstName?.toLowerCase() || "";
          const userInfoLastName = item.user?.userInfo?.lastName?.toLowerCase() || "";
          const fullName = `${userInfoFirstName} ${userInfoLastName}`.trim().toLowerCase();
          
          return (
            email.includes(searchLower) ||
            investorType.includes(searchLower) ||
            entityName.includes(searchLower) ||
            fullName.includes(searchLower) ||
            userInfoFirstName.includes(searchLower) ||
            userInfoLastName.includes(searchLower)
          );
        });
      }

      filteredData = filteredData?.sort((a, b) => new Date(b?.createdAt || 0) - new Date(a?.createdAt || 0));
      setuserStatusData(filteredData || []);
    } else {
      // If no userData or empty array, set empty array
      setuserStatusData([]);
    }
  }, [userData, searchText]);

  const handleClick = (event, dataIndex) => {
    setSelectedRow(dataIndex);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  // First, create a function to get completed custodians
  const getCompletedCustodians = (kycStatuses) => {
    return kycStatuses?.filter(status =>
      status?.status === "COMPLETED"
    ) || [];
  };

  const handleVerifyKyc = (userdata, completedCustodians) => {
    setSelectedUser({
      ...userdata,
      completedCustodians // Add completed custodians to the selected user data
    });
    setopenUserModalKyc(true);
    setAnchorEl(null);
  };


  const handleEdit = (rowData) => {
    navigate(`/user/${rowData?.id}`);
    setAnchorEl(null);
  };


  const handleInitialViewKyc = (userData) => {
    setTempUserData(userData);
    setSelectedCustodians([]);
    setOpenCustodianSelect(true);
    setAnchorEl(null);
  };

  const handleViewKyc = async () => {
    if (!tempUserData?.kyc?._id || selectedCustodians.length === 0) return;

    const body = {
      kycId: tempUserData.kyc._id,
      body: {
        custodians: selectedCustodians
      }
    };

    try {
      const response = await dispatch(GetKycById(body)).unwrap();
      if (response?.statusCode === 201) {

        setKycDetailsData(response.data);
        setSelectedCustodianForKyc(selectedCustodians[0]);
        setShowKycDetails(true);
        setOpenCustodianSelect(false);
      }
    } catch (error) {
      console.error('Error fetching KYC details:', error);
    }
  };

  const handleBackToTable = () => {
    setShowKycDetails(false);
    setKycDetailsData(null);
    setSelectedCustodianForKyc(null);
    setCurrentPage(0);
    setAnchorEl(null);
  };

  const handleComplete = async () => {
    if (!kycDetailsData?._id || !selectedCustodianForKyc) return;

    const statusObj = {
      _id: kycDetailsData._id,
      status: "COMPLETED", // or whatever status you want to set
      custodians: [selectedCustodianForKyc]
    };

    try {
      await dispatch(UserKycChange(statusObj)).unwrap();
      // Refresh the table data
      await dispatch(GetUserStatusTable());
      // Close the KYC details view and reset states
      handleBackToTable();
      // Show success message if you have a notification system
    } catch (error) {
      console.error('Error updating KYC status:', error);
      // Show error message if you have a notification system
    }
  };

  // Security function to validate URLs for iframe loading (prevent reverse tabnabbing)
  const validateIframeUrl = (url) => {
    if (!url || typeof url !== 'string') {
      console.error('Invalid iframe URL provided:', url);
      return false;
    }

    const cleanUrl = url.startsWith('@') ? url.substring(1) : url;

    try {
      const urlObj = new URL(cleanUrl);

      // Only allow safe protocols for iframe loading
      const allowedProtocols = ['https:', 'blob:', 'data:'];
      if (!allowedProtocols.includes(urlObj.protocol)) {
        console.error('Blocked unsafe iframe protocol:', urlObj.protocol, 'URL:', cleanUrl);
        return false;
      }

      // Block dangerous schemes that could cause reverse tabnabbing
      const blockedProtocols = ['javascript:', 'vbscript:', 'file:', 'ftp:', 'http:'];
      if (blockedProtocols.some(blocked => cleanUrl.toLowerCase().startsWith(blocked))) {
        console.error('Blocked dangerous iframe scheme:', cleanUrl);
        return false;
      }

      // For data URLs, be extra strict
      if (urlObj.protocol === 'data:') {
        const allowedDataTypes = ['application/pdf', 'image/'];
        const dataType = cleanUrl.substring(5).split(';')[0];
        if (!allowedDataTypes.some(allowed => dataType.startsWith(allowed))) {
          console.error('Blocked unsafe iframe data URL type:', dataType);
          return false;
        }
      }

      return true;
    } catch (error) {
      // For relative URLs, only allow trusted paths
      if (cleanUrl.startsWith('/') && !cleanUrl.includes('..')) {
        return true;
      }

      console.error('Invalid iframe URL format:', cleanUrl, error);
      return false;
    }
  };

  // Security function to validate and sanitize URLs
  const validateFileUrl = (url) => {
    if (!url || typeof url !== 'string') {
      console.error('Invalid URL provided:', url);
      return null;
    }

    // Remove @ prefix if present
    const cleanUrl = url.startsWith('@') ? url.substring(1) : url;

    try {
      const urlObj = new URL(cleanUrl);

      // Only allow safe protocols
      const allowedProtocols = ['http:', 'https:', 'blob:', 'data:'];
      if (!allowedProtocols.includes(urlObj.protocol)) {
        console.error('Blocked unsafe URL protocol:', urlObj.protocol, 'URL:', cleanUrl);
        return null;
      }

      // Block javascript: and other dangerous schemes
      const blockedProtocols = ['javascript:', 'vbscript:', 'file:', 'ftp:'];
      if (blockedProtocols.some(blocked => cleanUrl.toLowerCase().startsWith(blocked))) {
        console.error('Blocked dangerous URL scheme:', cleanUrl);
        return null;
      }

      // Additional validation for data URLs
      if (urlObj.protocol === 'data:') {
        // Only allow safe data URL types
        const allowedDataTypes = ['image/', 'application/pdf', 'text/plain', 'text/csv'];
        const dataType = cleanUrl.substring(5).split(';')[0];
        if (!allowedDataTypes.some(allowed => dataType.startsWith(allowed))) {
          console.error('Blocked unsafe data URL type:', dataType);
          return null;
        }
      }

      return cleanUrl;
    } catch (error) {
      // If URL constructor fails, try to validate as relative URL
      if (cleanUrl.startsWith('/') || cleanUrl.startsWith('./') || cleanUrl.startsWith('../')) {
        // Allow relative URLs but sanitize them
        return cleanUrl.replace(/[<>"']/g, '');
      }

      console.error('Invalid URL format:', cleanUrl, error);
      return null;
    }
  };

  const handleViewFile = async (fileUrl) => {
    const validatedUrl = validateFileUrl(fileUrl);

    if (!validatedUrl) {
      console.error('Cannot view file: Invalid or unsafe URL provided');
      // You could show a user-friendly error message here
      alert('Invalid file URL. Cannot view file.');
      return;
    }

    setFileToView(validatedUrl);
    setIsLoadingFile(true);
    setCsvData(null);
    setIsLoadingFile(false);
    setFileViewerOpen(true);
  };

  const handleDownloadFile = (fileUrl) => {
    const validatedUrl = validateFileUrl(fileUrl);

    if (!validatedUrl) {
      console.error('Cannot download file: Invalid or unsafe URL provided');
      alert('Invalid file URL. Cannot download file.');
      return;
    }

    // Create a secure download
    const link = document.createElement('a');
    link.href = validatedUrl;
    link.download = ''; // Let browser determine filename
    link.target = '_blank';
    link.rel = 'noopener noreferrer'; // Security best practice

    // Trigger download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleAccountIds = async (userData) => {
    setSelectedUserForAccountIds(userData);
    setAccountIdsModalOpen(true);
    setAnchorEl(null);

    try {
      await dispatch(GetAllUserStrategies({
        userEmail: userData?.user?.email || ''
      }));
    } catch (error) {
      console.error('Error fetching user strategies:', error);
    }
  };

  const handleAccountIdChange = (id, value) => {
    if (/^\d*$/.test(value)) {
      setAccountIds(prev => ({
        ...prev,
        [id]: value,
      }));
    }
  };

  const handleUpdateAccountIds = async () => {

    const payloadUserStrategy = allUserStrategies
    .map(item => {
      const typedAccountId = accountIds[item.id];
      const finalAccountId = (typedAccountId !== undefined) ? typedAccountId : (item.accountId ?? null);

      return {
        managementFeesTiers: item.managementFeesTiers || item.strategy?.managementFeesTiers || [{ limit: 0, fee: 5 }],
        performanceFeesPercentage: item.performanceFeesPercentage || item.strategy?.performanceFeesPercentage || null,
        hurdleRateType: item?.hurdleRateType || item.strategy?.hurdleRateType || null,
        hurdleRatePercentage: item.hurdleRatePercentage || item.strategy?.hurdleRatePercentage || null,
        performanceBenchmark: item?.performanceBenchmark || item.strategy?.performanceBenchmark || null,
        id: item.id || '',
        accountId: (finalAccountId !== null && finalAccountId !== undefined && finalAccountId !== '') ? Number(finalAccountId) : null, 
      };
    })
    .filter(Boolean); 
    try {
      await dispatch(PatchUserStrategies(payloadUserStrategy))
      // Refresh strategies so UI reflects updates
      await dispatch(GetAllUserStrategies({
        userEmail: selectedUserForAccountIds?.user?.email || ''
      }));
    } catch (error) {
      console.error('Error fetching account id strategies:', error);
    }


    // Add your API call logic here
    setAccountIdsModalOpen(false);
    setSelectedUserForAccountIds(null);
    setEditableAccountIds({});
    setAccountIds({});
  };

  const handleEditIcon = (item) => {
    if (!item || !item.id) return;
    setEditableAccountIds(prev => ({ ...prev, [item.id]: true }));
    // Focus the corresponding textfield after making it editable
    setTimeout(() => {
      const input = accountIdInputRefs.current[item.id];
      if (input) {
        input.focus();
        if (typeof input.select === 'function') input.select();
      }
    }, 0);
  }


  const handleCloseAccountIdsModal = () => {
    setAccountIdsModalOpen(false);
    setSelectedUserForAccountIds(null);
    setAccountIds({});
  };

  const data = userStatusData?.map((item, index) => {
    const { email, createdAt, isEmailVerified } = item.user || {};
    const emailStatus = isEmailVerified ? "APPROVED" : "PENDING";
    const investorType = item?.investorType || null;
    // const formattedDate = createdAt ? moment(createdAt).format("DD/MM/YYYY") : "N/A";

    return [
      index + 1,
      email || "N/A",
      // formattedDate,
      investorType,
      item.kyc || null,
      emailStatus,
    ];
  });

  const columns = [
    {
      name: "#",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {
            color: '#737373',
            fontWeight: '600'
          }
        }),
        customBodyRender: (value) => {
          return (
            <div
              style={{ marginLeft: "0px", fontSize: "13px", minWidth: "10px", textAlign: "left" }}
            >
              <div>{value}</div>
            </div>
          );
        },
      },
    },
    {
      name: "Email",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {
            color: '#737373',
            fontWeight: '600'
          }
        }),
        customBodyRender: (value) => {
          return (
            <div style={{ fontSize: "13px", width: "180px", fontWeight: "600", marginLeft: "5px", }}>{value}</div>
          );
        },
      },
    },
    // {
    //   name: "Reg Date",
    //   options: {
    //     filter: true,
    //     customBodyRender: (value) => {
    //       return (
    //         <div
    //           style={{ marginLeft: "0px", fontSize: "13px", width: "180px", fontWeight: "600", textAlign: "left" }}
    //         >

    //           {value}
    //         </div>
    //       );
    //     },
    //   },
    // },
    {
      name: "Investor Type",
      options: {
        setCellHeaderProps: () => ({
          style: {
            color: '#737373',
            fontWeight: '600'
          }
        }),
        customBodyRender: (value) => {
          return (
            <div
              style={{ marginLeft: "5px", fontSize: "13px", width: "150px", fontWeight: "400" }}
            >
              {value}
            </div>
          );
        },
      },
    },
    {
      name: "KYC Status",
      options: {
        filter: true,
        setCellHeaderProps: () => ({
          style: {
            color: '#737373',
            fontWeight: '600'
          }
        }),
        customBodyRender: (value, tableMeta) => {
          const userdata = userStatusData[tableMeta.rowIndex];
          const kycStatuses = userdata?.kyc?.statuses || [];

          // If no KYC data available, show "N/A"
          if (!kycStatuses || kycStatuses.length === 0) {
            return (
              <div style={{ fontSize: "13px", minWidth: "350px", width: "100%", color: "#9CA3AF" }}>
                N/A
              </div>
            );
          }

          return (
            <div style={{ fontSize: "13px", minWidth: "350px", width: "100%" }}>
              {kycStatuses.map((status, index) => {
                let color = "";
                let icon = null;
                const statusValue = status?.status || '';
                const custodian = status?.custodian || 'Unknown';

                switch (statusValue) {
                  case "IN_PROGRESS":
                    color = "orange";
                    icon = <HourglassEmptyIcon fontSize="small" />;
                    break;
                  case "COMPLETED":
                    color = "#00b300"; // Dark green
                    icon = <CheckCircleIcon fontSize="small" />;
                    break;
                  case "APPROVED":
                    color = "#4CAF50"; // Material UI green
                    icon = <CheckCircleIcon fontSize="small" />;
                    break;
                  case "REJECTED":
                    color = "#d32f2f"; // Material UI red
                    icon = <CancelIcon fontSize="small" />;
                    break;
                  case "IN_ADMIN_APPROVAL":
                    color = "#1976d2"; // Material UI primary blue
                    icon = <HelpOutlineIcon fontSize="small" />;
                    break;
                  default:
                    color = "grey";
                    icon = <HelpOutlineIcon fontSize="small" />;
                    break;
                }

                return (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: index < kycStatuses.length - 1 ? "6px" : "0",
                      marginLeft: '-50px',
                      marginRight: '100px',
                      padding: "6px 8px",
                      backgroundColor: "rgba(0,0,0,0.02)",
                      borderRadius: "4px"
                    }}
                  >
                    <div style={{
                      width: "180px",
                      minWidth: "180px",
                      fontWeight: "400",
                      marginRight: "12px",
                      textAlign: "left",
                      whiteSpace: "nowrap"
                    }}>
                      {custodian}:
                    </div>
                    <div style={{
                      color: color,
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "400",
                      flex: 1
                    }}>
                      {icon}
                      <span style={{ marginLeft: "6px" }}>
                        {statusValue}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        },
      },
    },

    // {
    //   name: "Code",
    //   options: {
    //     customBodyRender: (value) => {
    //       return (
    //         <div
    //           style={{ marginLeft: "20px", fontSize: "13px", width: "100px" }}
    //         >
    //           {value}
    //         </div>
    //       );
    //     },
    //   },
    // },

    {
      name: "Actions",
      options: {
        filter: false,
        setCellHeaderProps: () => ({
          style: {
            color: '#737373',
            fontWeight: '600'
          }
        }),
        customBodyRenderLite: (dataIndex) => {
          const userdata = userStatusData[dataIndex];
          const kycStatuses = userdata?.kyc?.statuses || [];

          // Get completed custodians
          const completedCustodians = getCompletedCustodians(kycStatuses);
          const hasCompletedStatus = completedCustodians.length > 0;

          // Check if any custodian has APPROVED status
          const hasApprovedStatus = kycStatuses.some(status =>
            status?.status === "APPROVED"
          );

          // Check if any status is not REJECTED or IN_PROGRESS
          const hasViewableStatus = kycStatuses.some(status => {
            const currentStatus = status?.status;
            return currentStatus !== "REJECTED" && currentStatus !== "IN_PROGRESS";
          });


          const menuItems = [];

          // Only show Edit Account if any status is APPROVED
          if (hasApprovedStatus) {
            menuItems.push(
              <MenuItem
                key="edit"
                onClick={() => handleEdit(userdata)}
                disableRipple
              >
                <EditIcon />
                Edit Account
              </MenuItem>
            );
          }

          // Show View KYC if any status is not REJECTED or IN_PROGRESS
          if (hasViewableStatus) {
            menuItems.push(
              <MenuItem
                key="viewKyc"
                onClick={() => handleInitialViewKyc(userdata)}
                disableRipple
              >
                <RemoveRedEyeIcon />
                View KYC
              </MenuItem>
            );
          }

          // Show Add/Update Account IDs if any status is APPROVED
          if (hasApprovedStatus) {
            menuItems.push(
              <MenuItem
                key="accountIds"
                onClick={() => handleAccountIds(userdata)}
                disableRipple
              >
                <AccountBalanceIcon />
                Add/Update Account IDs
              </MenuItem>
            );
          }

          // Show Update KYC Status if any status is COMPLETED
          if (hasCompletedStatus) {
            menuItems.push(
              <MenuItem
                key="updateKycStatus"
                onClick={() => handleVerifyKyc(userdata, completedCustodians)}
                disableRipple
              >
                <EditLocationAltIcon />
                Update KYC Status
              </MenuItem>
            );
          }

          // Only enable the button if there are menu items to show
          const hasMenuItems = menuItems.length > 0;

          return (
            <div>
              <StyledButton
                id={`options-button-${dataIndex}`}
                aria-controls={`options-menu-${dataIndex}`}
                aria-haspopup="true"
                aria-expanded={open && selectedRow === dataIndex}
                variant="contained"
                disableElevation
                onClick={(e) => handleClick(e, dataIndex)}
                
                disabled={!hasMenuItems}
                sx={{
                  opacity: hasMenuItems ? 1 : 0.5,
                  cursor: hasMenuItems ? 'pointer' : 'not-allowed'
                }}
              >
                <MoreVertIcon />
              </StyledButton>
              <StyledMenu
                id={`options-menu-${dataIndex}`}
                anchorEl={anchorEl}
                open={open && selectedRow === dataIndex}
                onClose={handleClose}
              >
                {menuItems}
              </StyledMenu>
            </div>
          );
        },
      },
    },
  ];

  // Calculate the count based on whether search is active
  // When searching, use filtered data length; otherwise use API count
  const displayCount = searchText && searchText.trim() 
    ? userStatusData.length 
    : userDataCount || 0;

  const options = {
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    selectableRows: "none",
    pagination: true,
    count: displayCount,
    page: page,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [10, 20, 50, 100],
    search: true,
    searchText: searchText,
    onTableChange: (action, tableState) => {
      if (action === 'changePage') {
        setPage(tableState.page);
      } else if (action === 'changeRowsPerPage') {
        setRowsPerPage(tableState.rowsPerPage);
        setPage(0); // Reset to first page when changing rows per page
      } else if (action === 'search') {
        // Handle search change
        const newSearchText = tableState.searchText || "";
        setSearchText(newSearchText);
        setPage(0); // Reset to first page when searching
      }
    },
    serverSide: !(searchText && searchText.trim()), // Disable server-side when searching to show filtered results
    tableBodyHeight: "60vh",
    tableBodyMaxHeight: "60vh",
  };

  // If showing KYC details, render the details view instead of the table
  if (showKycDetails && kycDetailsData) {

    const { qnas = [], type = '', entity = '', statuses = [], createdAt = '', updatedAt = '' } = kycDetailsData;


    const processedQnas = qnas.map(qna => {
      return {
        questionId: qna.question?._id || '',
        question: qna.question?.text || qna.questionSnapshot || '',
        inputType: qna.question?.inputType || '',
        section: qna.question?.section || '',
        answers: qna.answers || [],
        custodians: qna.question?.custodians || []
      };
    });


    const totalPages = Math.ceil(processedQnas.length / itemsPerPage);
    const startIndex = currentPage * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentQuestions = processedQnas.slice(startIndex, endIndex);

    const custodianStatus = statuses.find(s => s.custodian === selectedCustodianForKyc)?.status || 'UNKNOWN';

    const getStatusColor = (status) => {
      switch (status) {
        case 'APPROVED':
          return 'success';
        case 'IN_ADMIN_APPROVAL':
          return 'warning';
        case 'COMPLETED':
          return 'info';
        default:
          return 'default';
      }
    };

    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        {/* Header Section */}
        <Paper
          elevation={0}
          sx={{
            p: 2,
            mb: 3,
            backgroundColor: 'primary.main',
            color: 'white',
            borderRadius: 2
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <IconButton
                onClick={handleBackToTable}
                sx={{ color: 'white', '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}
              >
                <ArrowBackIcon />
              </IconButton>
              {/* <Typography variant="h5" component="h1">
                KYC Details Review
              </Typography> */}
            </Box>
            <Chip
              label={custodianStatus}
              color={getStatusColor(custodianStatus)}
              sx={{ fontWeight: 'bold' }}
            />
          </Box>
        </Paper>

        {/* Enhanced Info Card */}
        <Card sx={{ mb: 3, borderRadius: 2 }}>
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <BusinessIcon color="primary" />
                    <Typography variant="subtitle1">
                      <strong>Custodian:</strong> {selectedCustodianForKyc}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <PersonIcon color="primary" />
                    <Typography variant="subtitle1">
                      <strong>Type:</strong> {type}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <ArticleIcon color="primary" />
                    <Typography variant="subtitle1">
                      <strong>Entity:</strong> {entity}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  <Typography variant="subtitle2" color="text.secondary">
                    <strong>Created:</strong> {moment(createdAt).format('DD/MM/YYYY HH:mm')}
                  </Typography>
                  <Typography variant="subtitle2" color="text.secondary">
                    <strong>Last Updated:</strong> {moment(updatedAt).format('DD/MM/YYYY HH:mm')}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {/* Questions and Answers */}
        <Box sx={{ mb: 4 }}>
          {currentQuestions.map((item, index) => (
            <Card
              key={`${item.questionId}-${index}`}
              sx={{
                mb: 2,
                borderRadius: 2,
                '&:hover': {
                  boxShadow: 3
                }
              }}
            >
              <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    color="primary"
                    sx={{ flex: 1 }}
                  >
                    {startIndex + index + 1}. {item.question || 'No question text available'}
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                    >
                      ID: {item.questionId}
                    </Typography>
                    {item.section && (
                      <Chip
                        size="small"
                        label={item.section}
                        color="default"
                        variant="outlined"
                      />
                    )}
                  </Box>
                </Box>
                <Divider sx={{ my: 1 }} />
                <Box sx={{ mt: 2 }}>
                  {Array.isArray(item.answers) && item.answers.length > 0 ? (
                    item.answers.map((answer, ansIndex) => {
                      // Extract filename from URL
                      let displayText = answer;
                      let fileType = null;

                      if (item.inputType === 'UPLOAD' && answer && typeof answer === 'string') {
                        try {
                          // Remove any @ prefix if present
                          const cleanUrl = answer.startsWith('@') ? answer.substring(1) : answer;
                          // Extract filename from URL
                          const urlParts = cleanUrl.split('/');
                          const filenameWithParams = urlParts[urlParts.length - 1];
                          // Remove any query parameters if present
                          displayText = filenameWithParams.split('?')[0];
                          // URL decode to handle special characters
                          displayText = decodeURIComponent(displayText);

                          // Determine file type for display
                          if (cleanUrl.match(/\.(jpeg|jpg|gif|png)$/i) || cleanUrl.includes('content-type=image%2F')) {
                            fileType = 'image';
                          } else if (cleanUrl.match(/\.(mp4|webm|mov)$/i) || cleanUrl.includes('content-type=video%2F')) {
                            fileType = 'video';
                          } else if (cleanUrl.match(/\.(pdf)$/i) || cleanUrl.includes('content-type=application%2Fpdf')) {
                            fileType = 'pdf';
                          } else if (cleanUrl.match(/\.(csv)$/i) || cleanUrl.includes('content-type=text%2Fcsv')) {
                            fileType = 'csv';
                          } else {
                            fileType = 'other';
                          }
                        } catch (error) {
                          console.error("Error extracting filename:", error);
                          displayText = answer;
                        }
                      }

                      return (
                        <Paper
                          key={ansIndex}
                          elevation={0}
                          sx={{
                            p: 2,
                            mb: 1,
                            backgroundColor: 'rgba(0,0,0,0.02)',
                            borderRadius: 1,
                            border: '1px solid rgba(0,0,0,0.05)',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            {fileType === 'image' && (
                              <Box
                                component="span"
                                sx={{
                                  width: 32,
                                  height: 32,
                                  borderRadius: 1,
                                  overflow: 'hidden',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  border: '1px solid rgba(0,0,0,0.1)'
                                }}
                              >
                                <img
                                  src={answer.startsWith('@') ? answer.substring(1) : answer}
                                  alt="Thumbnail"
                                  style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'cover' }}
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.parentNode.textContent = '🖼️';
                                  }}
                                />
                              </Box>
                            )}
                            {fileType === 'video' && <VideoFileIcon color="primary" />}
                            {fileType === 'pdf' && <PictureAsPdfIcon color="error" />}
                            {fileType === 'csv' && <TableChartIcon color="success" />}
                            {fileType === 'other' && <InsertDriveFileIcon color="action" />}
                            <Typography variant="body1">
                              {displayText || '(No answer provided)'}
                            </Typography>
                          </Box>

                          {item.inputType === 'UPLOAD' && answer && (
                            <Box sx={{ display: 'flex', gap: 1 }}>
                              {/* Only show View button for image and video files */}
                              {['image', 'video'].includes(fileType) && (
                                <Tooltip title="View File">
                                  <IconButton
                                    color="primary"
                                    size="small"
                                    onClick={() => handleViewFile(answer)}
                                    sx={{
                                      bgcolor: 'rgba(25, 118, 210, 0.08)',
                                      '&:hover': {
                                        bgcolor: 'rgba(25, 118, 210, 0.12)'
                                      }
                                    }}
                                  >
                                    <RemoveRedEyeIcon />
                                  </IconButton>
                                </Tooltip>
                              )}
                              <Tooltip title="Download File">
                                <IconButton
                                  color="secondary"
                                  size="small"
                                  onClick={() => handleDownloadFile(answer)}
                                  sx={{
                                    bgcolor: 'rgba(156, 39, 176, 0.08)',
                                    '&:hover': {
                                      bgcolor: 'rgba(156, 39, 176, 0.12)'
                                    }
                                  }}
                                >
                                  <GetAppIcon />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          )}
                        </Paper>
                      );
                    })
                  ) : (
                    <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                      No answers provided
                    </Typography>
                  )}
                </Box>
              </CardContent>
            </Card>
          ))}
        </Box>

        {/* Pagination Controls */}
        <Paper
          sx={{
            p: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: 2,
            position: 'sticky',
            bottom: 16,
            boxShadow: 3,
            bgcolor: 'background.paper'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <ButtonGroup variant="contained" size="medium">
              <Button
                onClick={() => setCurrentPage(prev => prev - 1)}
                disabled={currentPage === 0}
                startIcon={<NavigateBeforeIcon />}
              >
                Previous
              </Button>
              <Button
                sx={{
                  px: 2,
                  cursor: 'default',
                  '&:hover': {
                    bgcolor: 'primary.main'
                  }
                }}
              >
                {currentPage + 1} of {Math.max(1, totalPages)}
              </Button>
              <Button
                onClick={() => setCurrentPage(prev => prev + 1)}
                disabled={currentPage >= totalPages - 1}
                endIcon={<NavigateNextIcon />}
              >
                Next
              </Button>
            </ButtonGroup>
          </Box>

          {currentPage === totalPages - 1 && (
            <Box sx={{ display: 'flex', gap: 2 }}>
              {custodianStatus === 'IN_ADMIN_APPROVAL' && (
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleComplete}
                >
                  Complete
                </Button>
              )}
              <Button
                variant="contained"
                color="error"
                onClick={handleBackToTable}
              >
                Cancel
              </Button>
            </Box>
          )}
        </Paper>

        {/* File Viewer Modal */}
        <Dialog
          open={fileViewerOpen}
          onClose={() => setFileViewerOpen(false)}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            sx: {
              height: '90vh',
              maxHeight: '90vh',
              display: 'flex',
              flexDirection: 'column',
              ml: { xs: 0, md: 3, lg: 30 } // Responsive margin
            }
          }}
        >
          <DialogTitle sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: 1,
            borderColor: 'divider'
          }}>
            <Typography variant="h6">Document Viewer</Typography>
            <IconButton onClick={() => setFileViewerOpen(false)}>
              <CancelIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            p: 0,
            overflow: 'hidden'
          }}>
            {isLoadingFile ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <CircularProgress />
              </Box>
            ) : fileToView ? (
              validateIframeUrl(fileToView) ? (
                fileToView.toLowerCase().endsWith('.pdf') || fileToView.includes('content-type=application%2Fpdf') ? (
                  <iframe
                    src={fileToView}
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                    title="PDF Viewer"
                    sandbox="allow-scripts allow-same-origin allow-downloads allow-forms"
                    referrerPolicy="no-referrer"
                  />
                ) : fileToView.match(/\.(jpeg|jpg|gif|png)$/i) || fileToView.includes('content-type=image%2F') ? (
                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    bgcolor: 'black'
                  }}>
                    <img
                      src={fileToView}
                      alt="Document"
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain'
                      }}
                    />
                  </Box>
                ) : fileToView.toLowerCase().endsWith('.csv') || fileToView.includes('content-type=text%2Fcsv') ? (
                  <Box sx={{ p: 2, overflowX: 'auto', height: '100%' }}>
                    {csvData ? (
                      <Paper elevation={0} sx={{ minWidth: '100%', overflow: 'auto' }}>
                        <Table size="small" stickyHeader>
                          <TableHead>
                            <TableRow>
                              {csvData[0]?.map((cell, index) => (
                                <TableCell key={index} sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                                  {cell}
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {csvData.slice(1).map((row, rowIndex) => (
                              <TableRow key={rowIndex} hover>
                                {row.map((cell, cellIndex) => (
                                  <TableCell key={cellIndex}>{cell}</TableCell>
                                ))}
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Paper>
                    ) : (
                      <Typography variant="body1" sx={{ textAlign: 'center' }}>
                        Unable to parse CSV data
                      </Typography>
                    )}
                  </Box>
                ) : fileToView.match(/\.(mp4|webm|mov)$/i) || fileToView.includes('content-type=video%2F') ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', bgcolor: 'black' }}>
                    <video
                      controls
                      style={{ maxWidth: '100%', maxHeight: '100%' }}
                    >
                      <source src={fileToView} />
                      Your browser does not support video playback.
                    </video>
                  </Box>
                ) : (
                  <Box sx={{ p: 3, textAlign: 'center' }}>
                    <Typography variant="body1">
                      This file type cannot be previewed.
                    </Typography>
                    <Button
                      variant="contained"
                      onClick={() => handleDownloadFile(fileToView)}
                      sx={{ mt: 2 }}
                      startIcon={<ArticleIcon />}
                    >
                      Download File
                    </Button>
                  </Box>
                )
              ) : (
                <Box sx={{ p: 3, textAlign: 'center' }}>
                  <Typography variant="body1" color="error" sx={{ mb: 2 }}>
                    ⚠️ Security Warning: This file URL is not safe to display.
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    The file URL failed security validation and cannot be previewed for your protection.
                  </Typography>
                  <Button
                    variant="contained"
                    onClick={() => handleDownloadFile(fileToView)}
                    sx={{ mt: 2 }}
                    startIcon={<ArticleIcon />}
                  >
                    Try Download Instead
                  </Button>
                </Box>
              )
            ) : null}
          </DialogContent>
          <DialogActions sx={{ p: 2, borderTop: 1, borderColor: 'divider' }}>
            <Button
              onClick={() => setFileViewerOpen(false)}
              variant="outlined"
              color="secondary"
              sx={{ mr: 2 }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => handleDownloadFile(fileToView)}
              variant="contained"
              color="primary"
              startIcon={<GetAppIcon />}
            >
              Download
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    );
  }

  // Regular table view
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div style={{ marginTop: "20px", width: "100%" }}>
          <MUIDataTable
            data={data}
            options={options}
            columns={columns}
          />
        </div>
      )}

      <UserstatusModal
        openUserModal={openUserModal}
        setopenUserModal={setopenUserModal}
        selectedUser={selectedUser}
      />
      <UserKycModal
        openUserModalKyc={openUserModalKyc}
        setopenUserModalKyc={setopenUserModalKyc}
        selectedUser={selectedUser}
      />

      {/* Add the Custodian Selection Modal */}
      <Dialog
        open={openCustodianSelect}
        onClose={() => setOpenCustodianSelect(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{
          borderBottom: 1,
          borderColor: 'divider',
          pb: 1
        }}>
          Select Custodians to View KYC
        </DialogTitle>

        <DialogContent sx={{ mt: 2 }}>
          {!tempUserData?.kyc?.statuses?.some(status =>
            ['COMPLETED', 'APPROVED', 'IN_ADMIN_APPROVAL'].includes(status.status)
          ) ? (
            <Alert severity="info" sx={{ mt: 1 }}>
              No eligible custodians found with completed, approved, or in admin approval status.
            </Alert>
          ) : (
            <FormControl component="fieldset" sx={{ width: '100%' }}>
              <FormGroup>
                {tempUserData?.kyc?.statuses
                  ?.filter(status =>
                    ['COMPLETED', 'APPROVED', 'IN_ADMIN_APPROVAL'].includes(status.status)
                  )
                  .map((status) => (
                    <FormControlLabel
                      key={status.custodian}
                      control={
                        <Checkbox
                          checked={selectedCustodians.includes(status.custodian)}
                          onChange={() => {
                            setSelectedCustodians(prev => {
                              if (prev.includes(status.custodian)) {
                                return prev.filter(c => c !== status.custodian);
                              }
                              return [...prev, status.custodian];
                            });
                          }}
                        />
                      }
                      label={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography>{status.custodian}</Typography>
                          <Chip
                            label={status.status}
                            size="small"
                            color={
                              status.status === 'APPROVED' ? 'success' :
                                status.status === 'IN_ADMIN_APPROVAL' ? 'warning' : 'info'
                            }
                          />
                        </Box>
                      }
                    />
                  ))}
              </FormGroup>
            </FormControl>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={() => setOpenCustodianSelect(false)}
            variant="outlined"
            color="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={handleViewKyc}
            variant="contained"
            color="primary"
            disabled={selectedCustodians.length === 0}
          >
            View KYC
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add the Account IDs Modal */}
      <Dialog
        open={accountIdsModalOpen}
        onClose={handleCloseAccountIdsModal}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column'
          }
        }}
      >
        <DialogTitle sx={{
          borderBottom: 1,
          borderColor: 'divider',
          pb: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexShrink: 0
        }}>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600, color: '#1f2937' }}>
              Edit User Strategy Account IDs
            </Typography>
            <Typography variant="body2" sx={{ color: '#6b7280', mt: 0.5 }}>
              Please add or update Account IDs for appropriate user strategies
            </Typography>
          </Box>
          <IconButton onClick={handleCloseAccountIdsModal}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{
          p: 3,
          flex: 1,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <Box sx={{
            border: '1px solid #e5e7eb',
            borderRadius: 2,
            overflow: 'hidden',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            marginTop: "5px"
          }}>
            {/* Table Header */}
            <Box sx={{
              display: 'flex',
              backgroundColor: '#f9fafb',
              borderBottom: '1px solid #e5e7eb',
              flexShrink: 0
            }}>
              <Box sx={{
                flex: '0 0 180px',
                p: 2,
                borderRight: '1px solid #e5e7eb',
                fontWeight: 600,
                color: '#374151',
                minWidth: 0
              }}>
                Investor Info
              </Box>
              <Box sx={{
                flex: '0 0 180px',
                p: 2,
                borderRight: '1px solid #e5e7eb',
                fontWeight: 600,
                color: '#374151',
                minWidth: 0
              }}>
                Strategy
              </Box>
              <Box sx={{
                flex: '0 0 140px',
                p: 2,
                borderRight: '1px solid #e5e7eb',
                fontWeight: 600,
                color: '#374151',
                minWidth: 0
              }}>
                Custodian
              </Box>
              <Box sx={{
                flex: 1,
                p: 2,
                fontWeight: 600,
                color: '#374151',
                minWidth: 0
              }}>
                Account ID
              </Box>
            </Box>

            {/* Scrollable Table Body */}
            <Box sx={{
              flex: 1,
              overflowY: 'auto',
              maxHeight: '400px',
              
            }}>
              {strategiesLoading ? (
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '200px'
                }}>
                  <CircularProgress />
                </Box>
              ) : allUserStrategies && allUserStrategies.length > 0 ? (
                allUserStrategies.map((item, index) => (

                  <Box
                    key={index}
                    sx={{
                      display: 'flex',
                      borderBottom: '1px solid #e5e7eb',
                      '&:hover': {
                        backgroundColor: '#f8fafc'
                      }
                    }}
                  >
                    <Box sx={{
                      flex: '0 0 180px',
                      padding:'16px 8px',
                      borderRight: '1px solid #e5e7eb',
                      display: 'flex',
                      alignItems: 'center',
                      color: '#374151',
                      minWidth: 0,
                      fontSize:'14px !important'
                    }}>
                      {selectedUserForAccountIds?.user?.email || item?.userEmail || 'N/A'}
                    </Box>
                    <Box sx={{
                      flex: '0 0 180px',
                      padding:'16px 8px',
                      borderRight: '1px solid #e5e7eb',
                      display: 'flex',
                      alignItems: 'center',
                      color: '#374151',
                      minWidth: 0,
                      fontSize:'14px !important'
                    }}>
                      {item?.strategy?.name || 'N/A'}
                    </Box>
                    <Box sx={{
                      flex: '0 0 140px',
                      p: 2,
                      borderRight: '1px solid #e5e7eb',
                      display: 'flex',
                      alignItems: 'center',
                      minWidth: 0
                    }}>
                      <Chip
                        label={item?.strategy?.custodian || 'N/A'}
                        size="small"
                        sx={{
                          backgroundColor: item?.strategy?.custodian === 'COINBASE' ? '#eff6ff' :
                            item?.strategy?.custodian === 'IBKR' ? '#f0fdf4' : '#f3f4f6',
                          color: item?.strategy?.custodian === 'COINBASE' ? '#1e40af' :
                            item?.strategy?.custodian === 'IBKR' ? '#166534' : '#374151',
                          fontWeight: 500,
                          fontSize: '11px',
                          height: '22px',
                          maxWidth: '100%',
                          width: '130px',
                          '& .MuiChip-label': {
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            padding: '0 8px',
                            fontSize: '11px'
                          }
                        }}
                      />
                    </Box>
                    <Box sx={{
                      flex: 1,
                      p: 2,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      minWidth: 0
                    }}>
                      <TextField
                        fullWidth
                        size="small"
                        placeholder="Type here"
                        value={accountIds[item.id] !== undefined ? accountIds[item.id] : (item.accountId ?? '')}
                        onChange={(e) => handleAccountIdChange(item.id, e.target.value)}
                        onFocus={() => setTypingAccountIds(prev => ({ ...prev, [item.id]: true }))}
                        onBlur={() => setTypingAccountIds(prev => ({ ...prev, [item.id]: false }))}
                        inputRef={(el) => { if (el) accountIdInputRefs.current[item.id] = el; }}
                        InputProps={{
                          readOnly: !editableAccountIds[item.id] && (item?.accountId !== null && item?.accountId !== undefined && item?.accountId !== ''),
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor: '#d1d5db',
                            },
                            '&:hover fieldset': {
                              borderColor: '#9ca3af',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: '#3b82f6',
                            },
                          },
                        }}
                      />
                      {(item?.accountId !== null && item?.accountId !== undefined && item?.accountId !== '') && (
                        <IconButton 
                          onClick={() => handleEditIcon(item)} 
                          size="small" 
                          sx={{ color: '#3b82f6' }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      )}
                    </Box>
                  </Box>
                ))
              ) : (
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '200px',
                  color: '#6b7280'
                }}>
                  <Typography variant="body1">
                    No strategies found for this user
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        </DialogContent>

        <DialogActions sx={{
          p: 3,
          pt: 0,
          borderTop: 1,
          borderColor: 'divider',
          flexShrink: 0
        }}>
          <Button
            onClick={handleCloseAccountIdsModal}
            variant="outlined"
            sx={{
              px: 3,
              py: 1,
              mt: 2,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              fontSize: "14px",
              borderColor: "#d1d5db",
              color: "#6b7280",
              "&:hover": {
                borderColor: "#9ca3af",
                backgroundColor: "#f9fafb",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleUpdateAccountIds}
            disabled={!allUserStrategies || allUserStrategies.length === 0}
            variant="contained"
            sx={{
              px: 3,
              py: 1,
              mt: 2,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              fontSize: "14px",
              backgroundColor: "#6b7280",
              color: "white",
              "&:hover": {
                backgroundColor: "#4b5563",
              },
            }}
          >
            Update Account IDs
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UserStatusTable;
